<div *ngIf="inventory">
	<mat-toolbar color="accent" mat-scroll-shrink>
		<a [routerLink]="['/inventory', id, 'show']" class="sneak-peek-title">{{ inventory?.uniqueId }}</a>

		<span class="example-fill-remaining-space"></span>

		<button mat-icon-button (click)="closeSide()">
			<ca-icon [key]="'CLOSE'"></ca-icon>
		</button>
	</mat-toolbar>

	<div class="ca-card ca-card-sneak-peek">
		<mat-card caCard>
			<mat-card-content>
				<div fxLayout="row" class="entry-list">
					<div fxFlex class="entry-list-item">
						<label>Vendor</label>
						<p>
							{{ inventory?.vendor?.name || 'N/A' }}
						</p>
					</div>
					<div fxFlex class="entry-list-item">
						<label>Type</label>
						<p>
							{{ inventory?.type?.value }}
						</p>
					</div>
				</div>

				<div fxLayout="row" class="entry-list">
					<div fxFlex class="entry-list-item">
						<label>Install Date</label>
						<p>
							{{ (inventory?.installDate | caDate) || 'N/A' }}
						</p>
					</div>
					<div fxFlex class="entry-list-item">
						<label>Status</label>
						<p>
							{{ inventory?.status?.value || 'N/A' }}
						</p>
					</div>
				</div>

				<div fxLayout="row" class="entry-list">
					<div fxFlex class="entry-list-item">
						<label>Internal ID</label>
						<p>
							{{ inventory?.internalId || 'N/A' }}
						</p>
					</div>
				</div>
			</mat-card-content>
		</mat-card>
	</div>

	<div *ngIf="inventory?.topologyId === INVENTORY_TOPOLOGY.POINT_TO_POINT">
		<div class="ca-card ca-card-sneak-peek">
			<mat-card caCard>
				<mat-card-content>
					<div class="flex-item" fxFlex>
						<div fxLayout="row" class="entry-list">
							<div fxFlex class="entry-list-item">
								<label>Site A (Carrier Location)</label>
								<p>
									{{ inventory?.siteA?.siteId || 'N/A' }}
								</p>
							</div>
						</div>
						<div fxLayout="row" class="entry-list">
							<div fxFlex class="entry-list-item">
								<label>Vendor</label>
								<p>
									{{ inventory?.siteA?.vendor?.name || 'N/A' }}
								</p>
							</div>
							<div fxFlex class="entry-list-item">
								<label>Building</label>
								<p>
									{{ inventory?.siteA?.building?.name || 'N/A' }}
								</p>
							</div>
						</div>
						<div fxLayout="row" class="entry-list">
							<div fxFlex class="entry-list-item">
								<label>Site type</label>
								<p>
									{{ inventory?.siteA?.siteType?.value || 'N/A' }}
								</p>
							</div>
							<div fxFlex class="entry-list-item">
								<label>Address</label>
								<p>
									{{ inventory?.siteA?.building?.address?.searchAddress || 'N/A' }}
								</p>
							</div>
						</div>
					</div>
				</mat-card-content>
			</mat-card>
		</div>

		<!-- site z -->
		<div class="ca-card ca-card-sneak-peek">
			<mat-card caCard>
				<mat-card-content>
					<div class="flex-item" fxFlex>
						<div fxLayout="row" class="entry-list">
							<div fxFlex class="entry-list-item">
								<label>Site Z (Customer Location)</label>
								<p>
									{{ inventory?.siteZ?.siteId || 'N/A' }}
								</p>
							</div>
						</div>
						<div fxLayout="row" class="entry-list">
							<div fxFlex class="entry-list-item">
								<label>Vendor</label>
								<p>
									{{ inventory?.siteZ?.vendor?.name || 'N/A' }}
								</p>
							</div>
							<div fxFlex class="entry-list-item">
								<label>Building</label>
								<p>
									{{ inventory?.siteZ?.building?.name || 'N/A' }}
								</p>
							</div>
						</div>
						<div fxLayout="row" class="entry-list">
							<div fxFlex class="entry-list-item">
								<label>Site type</label>
								<p>
									{{ inventory?.siteZ?.siteType?.value || 'N/A' }}
								</p>
							</div>
							<div fxFlex class="entry-list-item">
								<label>Address</label>
								<p>
									{{ inventory?.siteZ?.building?.address?.searchAddress || 'N/A' }}
								</p>
							</div>
						</div>
					</div>
				</mat-card-content>
			</mat-card>
		</div>
	</div>
</div>

<div *ngIf="!inventory" class="ca-empty-state-container">
	<p class="small-div-message">No item selected.</p>
</div>
